import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "@/App.css";
import { TopBar, SiteHeader, Marquee } from "@/components/Chrome";
import HeroSection from "@/components/HeroSection";
import EmpathySection from "@/components/EmpathySection";
import VideoSection from "@/components/VideoSection";
import TriadSection from "@/components/TriadSection";
import ChaptersSection from "@/components/ChaptersSection";
import InteractiveSection from "@/components/InteractiveSection";
import StoriesSection from "@/components/StoriesSection";
import FaithSection from "@/components/FaithSection";
import OfferSection from "@/components/OfferSection";
import FAQSection from "@/components/FAQSection";
import SOSWidget from "@/components/SOSWidget";
import Footer from "@/components/Footer";
import CheckoutModal from "@/components/CheckoutModal";
import BookReader from "@/components/BookReader";
import PaymentResult from "@/components/PaymentResult";
import AdminLogin from "@/components/AdminLogin";
import AdminDashboard from "@/components/AdminDashboard";
import AssistantChat from "@/components/AssistantChat";

function HomePage({ onPurchase, theme, onToggleTheme }) {
  return (
    <div className="app-shell">
      <TopBar />
      <SiteHeader onPurchase={onPurchase} theme={theme} onToggleTheme={onToggleTheme} />
      <main>
        <HeroSection onPurchase={onPurchase} />
        <Marquee />
        <EmpathySection />
        <VideoSection />
        <AssistantChat />
        <TriadSection />
        <ChaptersSection />
        <InteractiveSection />
        <StoriesSection />
        <FaithSection />
        <OfferSection onPurchase={onPurchase} />
        <FAQSection />
        <SOSWidget />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const [theme, setTheme] = useState(() => localStorage.getItem("liberdade-theme") || "light");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("liberdade-theme", theme);
  }, [theme]);

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <HomePage
              onPurchase={() => setCheckoutOpen(true)}
              theme={theme}
              onToggleTheme={() => setTheme(theme === "dark" ? "light" : "dark")}
            />
          }
        />
        <Route path="/pagamento/:result" element={<PaymentResult />} />
        <Route path="/leitura" element={<BookReader />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
      <CheckoutModal open={checkoutOpen} onClose={() => setCheckoutOpen(false)} />
    </BrowserRouter>
  );
}

export default App;
